/**
 * i18n configuration – single source for supported languages and namespaces.
 * Import this file first (e.g. in index.js) so i18next is ready before React.
 */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

export const SUPPORTED_LANGUAGES = ["en", "de", "es"];
export const DEFAULT_LANGUAGE = "de";
export const LANGUAGE_STORAGE_KEY = "swobbee.portal.language";

export const NAMESPACES = [
  "translation",
  "sharingPoints",
  "sharingPointOverview",
  "sharingPointTable",
  "batteries",
  "descriptions",
];

/** Set at compile time in config-overrides (DefinePlugin); busts HTTP/CDN cache for locale files. */
const I18N_BUILD_STAMP =
  typeof process !== "undefined" && process.env.REACT_APP_BUILD_STAMP
    ? process.env.REACT_APP_BUILD_STAMP
    : "";

const localeLoadPath =
  I18N_BUILD_STAMP.length > 0
    ? `/locales/{{lng}}/{{ns}}.json?v=${encodeURIComponent(I18N_BUILD_STAMP)}`
    : "/locales/{{lng}}/{{ns}}.json";

const detectionOptions = {
  order: ["localStorage", "navigator"],
  lookupLocalStorage: LANGUAGE_STORAGE_KEY,
  caches: ["localStorage"],
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES,
    ns: NAMESPACES,
    defaultNS: "translation",
    detection: detectionOptions,
    backend: {
      loadPath: localeLoadPath,
      requestOptions: {
        cache: "no-cache",
      },
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true,
    },
  });

function migrateStoredLanguage() {
  try {
    if (localStorage.getItem(LANGUAGE_STORAGE_KEY)) return;
    const raw = localStorage.getItem("LANGUAGE");
    if (!raw) return;
    const lang = typeof raw === "string" && raw.startsWith("{") ? JSON.parse(raw) : raw;
    if (lang && SUPPORTED_LANGUAGES.includes(lang)) {
      localStorage.setItem(LANGUAGE_STORAGE_KEY, lang);
    }
  } catch (_) {}
}

if (typeof window !== "undefined") migrateStoredLanguage();

export default i18n;
